import styled from "styled-components"
import tw from "tailwind.macro"

export const WrapperPricing = styled.div`
  max-width: 885px;
  padding-top: 80px;
  ${tw`mx-auto`}
`
